
import LHead from "@/components/layout/0_head.vue";
import LBody from "@/components/layout/1_body.vue";
import LFoot from "@/components/layout/2_foot.vue";

export default {
	name: "layout",
	components: {LFoot, LBody, LHead},
}
